export const RENEW_PREFIX = 'rr-';

export const FLOW_TYPE = {
	AV: 'av',
	EB: 'eb',
	ER: 'er',
	MV: 'mv',
	ES_MV: 'es-mv',
	RR_EB: `${RENEW_PREFIX}eb`,
	RR_ER: `${RENEW_PREFIX}er`,
	RR_MV: `${RENEW_PREFIX}mv`,
	RR_SU: `${RENEW_PREFIX}su`
};

export type EntityType = 'individual' | 'legal-entity';

export type FlowType = keyof typeof FLOW_TYPE;

export const ENTITY_TYPE = {
	INDIVIDUAL: 'individual' as EntityType,
	LEGAL_ENTITY: 'legal-entity' as EntityType
};
